import request from '@/config/axios'

// AI 任务 VO
export interface AiTaskVO {
  id: number
  taskCode: string
  taskName: string
  taskType?: string
  employeeId?: number
  agentId?: number
  modelId?: number
  taskInput?: string
  taskConfig?: Record<string, any>
  taskOutput?: string
  resultOssId?: number
  status?: string
  priority?: number
  scheduledTime?: Date
  startedTime?: Date
  completedTime?: Date
  errorMessage?: string
  remark?: string
  createTime?: Date
}

// AI 任务 API
export const TaskApi = {
  // 获得任务分页
  getTaskPage: async (params: any) => {
    return await request.get({ url: '/ai/task/page', params })
  },

  // 获得任务详情
  getTask: async (id: number) => {
    return await request.get({ url: '/ai/task/get?id=' + id })
  },

  // 创建任务
  createTask: async (data: AiTaskVO) => {
    return await request.post({ url: '/ai/task/create', data })
  },

  // 更新任务
  updateTask: async (data: AiTaskVO) => {
    return await request.put({ url: '/ai/task/update', data })
  },

  // 删除任务
  deleteTask: async (id: number) => {
    return await request.delete({ url: '/ai/task/delete?id=' + id })
  },

  // 执行任务
  executeTask: async (id: number) => {
    return await request.post({ url: `/ai/task/${id}/execute` })
  },

  // 取消任务
  cancelTask: async (id: number) => {
    return await request.put({ url: `/ai/task/${id}/cancel` })
  },

  // 获得任务运行日志
  getTaskLogs: async (id: number) => {
    return await request.get({ url: `/ai/task/${id}/logs` })
  },

  // 获得任务运行事件
  getTaskEvents: async (id: number, afterId = 0) => {
    return await request.get({ url: `/ai/task/${id}/events?afterId=${afterId}` })
  }
}
